<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('edit') }} {{ $t('ticketpriceconfiguration') }}</div>
      <router-link
        class="btn-blue"
        to="ticket-price-configurations"
      >{{ $t('ticketpriceconfiguration') }} {{ $tc('list', 2) }}</router-link>
    </div>

    <div class="add-movie-container">
      <form class="row">
        <!-- Cinemas -->
        <div class="col-md-6 mb-4">
          <div class>
            <label>{{ $tc('cinema', 2) }}</label>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selectedCinema" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(Cinema, CinemaIndex) in Cinemas"
                :key="CinemaIndex"
                v-on:click="onSelectCinema($event, Cinema)"
              >{{ Cinema.cine_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('ticketPriceConfiguration_cinemas')" />
          </div>
          <p class="error_msg">{{ $t('titleempty') }}</p>
        </div>

        <!-- Movies -->
        <div class="col-md-6 mb-4">
          <div class>
            <label>{{ $tc('movie', 1) }}</label>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selectedMovie" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(Movie, MovieIndex) in Movies"
                v-on:click="onSelectMovie($event, Movie)"
                :key="MovieIndex"
              >{{ Movie.movie }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('ticketPriceConfiguration_Movie')" />
          </div>
          <p class="error_msg">{{ $t('titleempty') }}</p>
        </div>

        <!-- Screen -->
        <div class="col-md-6 mb-4">
          <div class>
            <label>{{ $t('screens') }}</label>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <b-dropdown :text="selectedScreen" variant="dropdown-curve" class="w-100">
              <b-dropdown-item
                v-for="(Screen, ScreenIndex) in Screens"
                @click="onSelectScreen($event, Screen)"
                :key="ScreenIndex"
              >{{ Screen.screen_name }}</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('ticketPriceConfiguration_Screens')" />
          </div>
          <p class="error_msg">{{ $t('titleempty') }}</p>
        </div>

        <!-- FromDate -->
        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker :monday-first="true"
                  v-model="SchedulePriceObject.ss_start_date"
                  @selected="onSelectDate($event,'ss_start_date')"
                  ref="programaticOpen"
                ></Datepicker>
                <label
                  :class="['',SchedulePriceObject.ss_start_date ? 'active' : '']"
                >{{ $t('fromdate') }}</label>
              </div>
            </div>
            <Tooltip :title="$t('ticketPriceConfiguration_FromDate')" />
          </div>
          <p class="error_message">{{ $t('blankfieldmsg') }}</p>
        </div>

        <!--ToDate -->
        <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker :monday-first="true"
                  v-model="SchedulePriceObject.ss_end_date"
                  @selected="onSelectDate($event,'ss_end_date')"
                  ref="programaticOpen"
                ></Datepicker>
                <label
                  :class="['',SchedulePriceObject.ss_end_date ? 'active' : '']"
                >{{ $t('fromdate') }}</label>
              </div>
            </div>
            <Tooltip :title="$t('ticketPriceConfiguration_ToDate')" />
          </div>
          <p class="error_message">{{ $t('blankfieldmsg') }}</p>
        </div>
      </form>

      <div
        class="row"
        v-for="(SchedulePrice, SchedulePriceIndex) in SchedulePriceList"
        :key="SchedulePriceIndex"
      >
        <div class="col-12">
          <div class="row">
            <div class="col-4 mb-4" v-for="(item,itemIndex) in SchedulePrice.list" :key="itemIndex">
              <div v-if="itemIndex == 0">
                <div v-if="SchedulePriceIndex == 0" class="text-center">{{ item.label }}</div>
                <div class="input-container mw-auto">
                  <input :value="item.o" disabled type="text" />
                </div>
              </div>
              <div v-if="itemIndex !== 0">
                <div v-if="SchedulePriceIndex == 0" class="text-center">{{ item.label }}</div>
                <b-dropdown
                  :text="item.rc_name"
                  variant="dropdown-curve-lg bg-theme-light"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(Ratecard, RatecardIndex) in Ratecards"
                    @click="onSelectRatecard($event, Ratecard,SchedulePriceIndex, itemIndex)"
                    :key="RatecardIndex"
                  >{{ Ratecard.rc_name }} - {{ Ratecard.rc_total_amount }}</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center mt-4">
          <button
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>
          <button @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">{{ $t('save') }}</button>
          <button @click.prevent.stop="onResetForm" class="btn-black">{{ $t('reset') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="ticket-price-configurations"
          >{{ $t('cancel') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MovieService from "@/services/MovieService";
import ScreenService from "@/services/ScreenService";
import MasterService from "@/services/MasterService";
import moment from "moment";
import { resolve } from "url";

export default {
  data() {
    return {
      // Saif
      Cinemas: [],
      selectedCinema: "Select Cinema",
      Movies: [],
      selectedMovie: "Select Movie",
      Screens: [],
      selectedScreen: "Select Screen",
      SeatTypes: [],
      selectedSeatTypes: "Select Seat Types",
      ScheduleShowTimes: [],
      selectedScheduleShowTime: "Select Time",

      SchedulePriceList: [],
      SchedulePriceObject: {
        currency_id: null,
        cine_id: null,
        screen_id: null,
        md_id: null,
        ss_id: null,
        ss_start_date: null,
        ss_end_date: null,
        p_start_date_time: null,
        p_end_date_time: null
      },

      Ratecards: [],
      FinalArray: [],
      getTicketPriceConfigurationDetails: []
      // Saif
    };
  },
  beforeMount() {
    // this._GetGlobalOptions();

    this.SchedulePriceObject.currency_id =
      this.secureStore.get("BRGLOPCU") && this.secureStore.get("BRGLOPCU").go_value
        ? this.secureStore.get("BRGLOPCU").go_value
        : null;

    const { md_id, ss_id } = this.$route.query;
    if (md_id && ss_id) {
      console.log("id :", md_id, ss_id);
      this.getTicketPriceConfiguration({ md_id, ss_id });
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    // saif
    onResetForm: function() {
      this.Cinemas = [];
      this.selectedCinema = "Select Cinema";
      this.Movies = [];
      this.selectedMovie = "Select Movie";
      this.Screens = [];
      this.selectedScreen = "Select Screen";
      this.SeatTypes = [];
      this.selectedSeatTypes = "Select Seat Types";
      this.ScheduleShowTimes = [];
      this.selectedScheduleShowTime = "Select Time";
      this.SchedulePriceList = [];
      this.SchedulePriceObject = {
        currency_id: null,
        cine_id: null,
        screen_id: null,
        md_id: null,
        ss_id: null,
        ss_start_date: null,
        ss_end_date: null,
        p_start_date_time: null,
        p_end_date_time: null
      };
      this.getTicketPriceConfigurationDetails = [];
      this.FinalArray = [];
    },
    getTicketPriceConfiguration: function({ md_id, ss_id }) {
      CinemasService.GetTicketPriceConfigurationById({ md_id, ss_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            console.log("data :", data);
            this.getTicketPriceConfigurationDetails = data.Records;
            let obj = data.Records[0];

            this.selectedCinema = obj.cine_name || "Select Cinema";
            this.SchedulePriceObject.cine_id = obj.cinema_id || null;
            this.selectedMovie = obj.movie_title || "Movie Name";
            this.SchedulePriceObject.md_id = obj.md_id || null;
            this.selectedScreen = obj.screen_name || "Select Screen";
            this.SchedulePriceObject.screen_id = obj.screen_id || null;

            this.SchedulePriceObject[
              "p_start_date_time"
            ] = obj.p_start_date_time
              ? moment(new Date(obj.p_start_date_time)).format(
                  "YYYY-MM-DD HH:mm:ss"
                )
              : null;
            this.SchedulePriceObject["p_end_date_time"] = obj.p_end_date_time
              ? moment(new Date(obj.p_end_date_time)).format(
                  "YYYY-MM-DD HH:mm:ss"
                )
              : null;

            this.SchedulePriceObject["ss_start_date"] = moment(
              new Date(obj.ss_start_date)
            ).format("YYYY-MM-DD");
            this.SchedulePriceObject["ss_end_date"] = moment(
              new Date(obj.ss_end_date)
            ).format("YYYY-MM-DD");

            Promise.all([
              this.getScheduleShowTimes(),
              this.getActiveSeatTypeByScreenId(obj.screen_id),
              this.getActiveRatecardByCinemaAndCurrencyId()
            ])
              .then(() => {
                this.onMakeSchedulePriceArray();
              })
              .catch(error => {
                console.error(err);
              });
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error Message :", error);
        });
    },
    getActiveSeatTypeByScreenId: function(screen_id) {
      return new Promise((resolve, reject) => {
        this.SeatTypes = [];
        if (screen_id) {
          let payload = {
            tableName: "screen_seat_type",
            sst_is_active: "Y",
            screen_id
          };
          MasterService.GetActiveList(payload)
            .then(response => {
              const { data } = response;

              if (data && data.status && data.Records.length > 0) {
                this.SeatTypes = data.Records;
                console.log("this.SeatTypes :", this.SeatTypes);
                // this.onMakeSchedulePriceArray();
              } else {
                // Shoe Error Message:
                console.log("data.message :", data.message);
              }
              resolve();
            })
            .catch(error => {
              // Catch Error:
              console.log(
                "Catch Error on getActiveSeatTypeByScreenId :",
                error
              );
              reject(error);
            });
        }
      });
    },
    getScheduleShowTimes: function() {
      return new Promise((resolve, reject) => {
        let payload = {
          cine_id: this.SchedulePriceObject.cine_id,
          movie_details_id: this.SchedulePriceObject.md_id,
          screen_id: this.SchedulePriceObject.screen_id,
          ss_start_date: this.SchedulePriceObject.ss_start_date,
          ss_end_date: this.SchedulePriceObject.ss_end_date
        };
        console.log("payload :", payload);
        CinemasService.GetTicketPriceConfiguration(payload)
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ScheduleShowTimes = data.Records;
              console.log("this.ScheduleShowTimes :", this.ScheduleShowTimes);
              // this.onMakeSchedulePriceArray();
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
            resolve();
          })
          .catch(error => {
            // Catch Error:
            console.log(
              "Catch Error on getTicketPriceConfigurationList :",
              error
            );
            reject(error);
          });
      });
    },
    getActiveRatecardByCinemaAndCurrencyId: function() {
      return new Promise((resolve, reject) => {
        this.Ratecards = [];

        if (
          this.SchedulePriceObject.cine_id &&
          this.SchedulePriceObject.currency_id
        ) {
          let payload = {
            cinema_id: this.SchedulePriceObject.cine_id,
            currency_id: this.SchedulePriceObject.currency_id
          };
          CinemasService.GetActiveRatecardByCinemaAndCurrencyId(payload)
            .then(response => {
              const { data } = response;
              if (data && data.status && data.Records.length > 0) {
                this.Ratecards = data.Records;
                console.log("this.Ratecards :", this.Ratecards);
              } else {
                // Show Message:
                console.log("data.message :", data.message);
              }
              resolve();
            })
            .catch(error => {
              // Catch Error:
              console.log(
                "Catch Error On getActiveRatecardByCinemaAndCurrencyId :",
                error
              );
              reject(error);
            });
        }
      });
    },
    onMakeSchedulePriceArray: function() {
      console.log(
        "this.SeatTypes.length > 0 && this.ScheduleShowTimes.length > 0 :",
        this.SeatTypes.length,
        this.ScheduleShowTimes.length
      );
      if (this.SeatTypes.length > 0 && this.ScheduleShowTimes.length > 0) {
        this.SchedulePriceList = [];
        this.ScheduleShowTimes.map(x => {
          let getExistingShowTime = this.getTicketPriceConfigurationDetails.filter(
            z => z.ss_id === x.ss_id
          );
          console.log("getExistingShowTime :", getExistingShowTime);
          // if (getExistingShowTime.length > 0) {
          let array = [];
          array.push({ label: "Time", ...x });
          this.SeatTypes.map(y => {
            let getExistingSeatTypes = this.getTicketPriceConfigurationDetails.filter(
              z => y.sst_id === z.screen_seat_type_id
            );
            // console.log("getExistingSeatTypes :", getExistingSeatTypes);
            if (getExistingSeatTypes.length > 0) {
              array.push({
                label: y.sst_seat_type,
                p_id: getExistingSeatTypes[0].p_id,
                rc_id: getExistingSeatTypes[0].rate_card_id,
                ss_id: x.ss_id,
                rc_name:
                  getExistingSeatTypes[0].rc_name +
                  " - " +
                  getExistingSeatTypes[0].rc_total_amount,
                ...y
              });
            } else {
              array.push({
                label: y.sst_seat_type,
                rc_id: null,
                p_id: null,
                ss_id: x.ss_id,
                rc_name: "Select Ratecard",
                ...y
              });
            }
          });
          this.SchedulePriceList.push({ list: array });
        });
        console.log("this.SchedulePriceList :", this.SchedulePriceList);
      }
    },
    onSelectRatecard: function(event, Ratecard, SchedulePriceIndex, itemIndex) {
      this.SchedulePriceList[SchedulePriceIndex].list[itemIndex].rc_id =
        Ratecard.rc_id;
      this.SchedulePriceList[SchedulePriceIndex].list[itemIndex].rc_name =
        Ratecard.rc_name + "-" + Ratecard.rc_total_amount;
    },
    getFinalPayload: async function() {
      this.FinalArray = [];
      let Promises = this.SchedulePriceList.map((x, xIndex) => {
        x.list.map((y, yIndex) => {
          if (yIndex !== 0 && y.rc_id) {
            this.FinalArray.push({
              p_id: y.p_id,
              rate_card_id: y.rc_id,
              cinema_id: this.SchedulePriceObject.cine_id,
              screen_id: this.SchedulePriceObject.screen_id,
              md_id: this.SchedulePriceObject.md_id,
              schedule_show_id: y.ss_id,
              screen_seat_type_id: y.sst_id,
              p_start_date_time: this.SchedulePriceObject.p_start_date_time
                ? moment(
                    new Date(this.SchedulePriceObject.p_start_date_time)
                  ).format("YYYY-MM-DD HH:mm:ss")
                : null,
              p_end_date_time: this.SchedulePriceObject.p_end_date_time
                ? moment(
                    new Date(this.SchedulePriceObject.p_end_date_time)
                  ).format("YYYY-MM-DD HH:mm:ss")
                : null,
              p_start_time_timestamp: this.SchedulePriceObject.p_start_date_time
                ? +new Date(this.SchedulePriceObject.p_start_date_time)
                : null || null,
              p_end_time_timestamp: this.SchedulePriceObject.p_end_date_time
                ? +new Date(this.SchedulePriceObject.p_end_date_time)
                : null || null,
              p_is_active: this.SchedulePriceObject.p_start_date_time
                ? "Y"
                : "N",
              created_at: new Date(),
              created_by: 1
            });
          }
          //
        });
      });
      return await Promise.all(Promises);
    },
    onFinalSubmit: function(redirect) {
      this.getFinalPayload()
        .then(result => {
          console.log("this.FinalArray :", this.FinalArray);
          let payload = {
            FinalArray: this.FinalArray
          };
          CinemasService.UpdatedPriceConfigurationById(payload)
            .then(response => {
              const { data } = response;
              if (data && data.status) {
                this.onResetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/master/ticket-price-configurations"
                  });
                }
              }
            })
            .catch(error => {
              // Catch Error:
              console.log("Catch Error on onFinalSubmit :", error);
            });
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch error on getFinalPayload :", error);
        });
    }
    // Saif
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/CinemaContainer/TicketPriceConfigurationComponents/editTicketPriceConfiguration.vue